<template>
    <v-container fluid>   
        <v-row class="mb-6">
                <v-card v-for="(course,index) in courses" :key="course.id" class="ms-3 mb-6" min-width="25em" >                    
                      <v-card-title style="color:#fff;cursor:pointer" @click="showCourse(course)" primary-title class="layout justify-center" :style="getStyle(area_color)">{{course.title}}</v-card-title>
                        <v-card-text @click="showCourse(course)" class="ml-3" >
                            <p>{{course.description}}</p>
                            <v-layout row wrap >                                 
                                <div class="flex xs6">
                                  <strong> Tasks: </strong> {{course.task_finished}} / {{course.task_all}}
                                </div>
                                <div class="flex xs6">
                                   <strong> Programs: </strong>{{course.program_finished}} / {{course.program_all}}
                                </div>
                                <v-flex v-if="isAdmin" xs12>
                                    {{course.content_all}}(C) + {{course.task_all}}(T) + {{course.program_all}}(P)
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions >
                            <div v-if="isAdmin">
                                    <p><v-icon class="icon-edit" @click="editCourse(course.id)">mdi-pencil</v-icon></p>
                                    <p><v-icon class="icon-delete" @click="deleteCourse(course.id)" >mdi-delete</v-icon></p>
                                    <p><v-icon v-if="index > 0" class="icon-up" @click="moveCourse(index, index-1)">mdi-arrow-left</v-icon></p>
                                    <p><v-icon v-if="index < courses.length-1" class="icon-down" @click="moveCourse(index, index+1)">mdi-arrow-right</v-icon></p>
                            </div>
                            <div v-if="!isAdmin">
                                Status: 
                                <span v-if="course.course_status == null" style="color:green" ><strong>new</strong></span>
                                <span v-if="course.course_status != null">{{course.course_status}}</span>
                            </div>
                        </v-card-actions> 
                        
                </v-card>
      
       
                <v-card v-if="$store.getters.isAdmin" class="mb-6 mx-auto">                    
                    <v-card-text>
                        <v-layout justify-center>
                            <v-icon size="x-large" @click="addCourse()">mdi-plus-circle-outline</v-icon> 
                        </v-layout>
                    </v-card-text>  
                </v-card>
        </v-row>
    </v-container>    
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            courses : [],
            area_color : "#000000",
            isAdmin: false
            
        }
    },
    mounted() {
        this.initData()
    },
    methods :{
        initData() {
            /* eslint-disable no-console */
            // console.log('courses redraw')
            this.$store.commit('setFeedback', null)
            this.$store.commit('setBcChange',true)
            this.isAdmin = this.$store.getters.isAdmin
            var address = '/area-all-courses/' + this.$route.params.id
            if (this.isAdmin) {
                address = '/area-all-courses2/' + this.$route.params.id
            } 


            axios.get(address, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                this.courses = res.data.list 
                this.area_color = res.data.area_color
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })            
            
        },
        getTargetLink(course) {
            if (this.isAdmin) return 'course_admin_content'
            // not admin
            if (course.course_status == null) return 'course_preview'
            return 'course_content'
        },
        addCourse() {
            this.$router.push({name:'admin_course', params: {id: '0'}})
        },
        editCourse(id) {
            this.$router.push({name:'admin_course', params: {id: id}})
        },
        deleteCourse(id) {
            this.$store.commit('setFeedback', null)    
            // get list
            axios.get('/delete-course/' + id, this.$store.getters.getAxiosConfig)
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        moveCourse(p1, p2) {
            const data = {
                course_id1: this.courses[p1].id,
                course_order1: this.courses[p1].course_order,
                course_id2: this.courses[p2].id,
                course_order2: this.courses[p2].course_order
            }
            axios.post('/course-change-order', data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var
                this.initData()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
      },
      showCourse(course) {
          this.$store.dispatch('setActiveCourse', {id: course.id, name: course.title} )
          this.$router.push({name:this.getTargetLink(course), params: {id: course.id}})          
      },
      getStyle(col) {
          return "color: white; background-color: "+col+"; margin-bottom: 0.5em;";
      }



    }
}
</script>

<style>
/*
.theme--light.v-card .v-card__text {
    color: #01A5D9;
}

.theme--light.v-icon {
    color: #00B1B0;
}

.v-application a {
    color: #01A5D9;
}

.v-card__title {
    cursor: pointer; 
}

.v-card__title+.v-card__text {
    padding-top: 0;
    text-align: center;
    font-weight: bolder;
}

.layout.wrap {
    color: grey; 
} 
*/
</style>